
import React from "react";

interface LearningMetricsSectionProps {
  learningMetrics: {
    historicalDataPoints: number;
    modelConfidence: number;
    inventoryBaseTermsFound?: number;
    exactMatchesFound?: number;
    exactSizeMatchesFound?: number;
  };
}

const LearningMetricsSection = ({ learningMetrics }: LearningMetricsSectionProps) => {
  return (
    <div>
      <h4 className="font-medium text-sm mb-2">Verbeterde AI Metrics</h4>
      <div className="grid grid-cols-5 gap-4 text-sm">
        <div className="text-center">
          <div className="text-lg font-bold text-blue-600">
            {learningMetrics.historicalDataPoints}
          </div>
          <div className="text-muted-foreground">Historisch</div>
        </div>
        <div className="text-center">
          <div className="text-lg font-bold text-purple-600">
            {Math.round(learningMetrics.modelConfidence * 100)}%
          </div>
          <div className="text-muted-foreground">AI Vertrouwen</div>
        </div>
        <div className="text-center">
          <div className="text-lg font-bold text-green-600">
            {learningMetrics.inventoryBaseTermsFound || 0}
          </div>
          <div className="text-muted-foreground">Basis Patronen</div>
        </div>
        <div className="text-center">
          <div className="text-lg font-bold text-orange-600">
            {learningMetrics.exactMatchesFound || 0}
          </div>
          <div className="text-muted-foreground">Product Matches</div>
        </div>
        <div className="text-center">
          <div className="text-lg font-bold text-emerald-600">
            {learningMetrics.exactSizeMatchesFound || 0}
          </div>
          <div className="text-muted-foreground">Maat Matches</div>
        </div>
      </div>
    </div>
  );
};

export default LearningMetricsSection;
